import './AccessStatisticsRow.scss';
import classNames from 'classnames';
import { FULL_ROUTES } from '@sonar-software/sonar-ts-constants';
import { hexToRgb } from '@lib/color';
import { SonarText } from '@ui/text';
import { Tag } from 'antd';
import { useNavigate } from 'react-router';
import { usePeriscopeActions } from '@hooks';
import React, { useCallback } from 'react';
const getBackgroundColor = (color) => {
    if (!color) {
        return;
    }
    const { r, g, b } = hexToRgb(color);
    return `rgba(${r},${g},${b}, .3)`;
};
export const AccessStatisticsRow = ({ className, clickable = true, color, colorName, count, extra, id, max, name, type }) => {
    const { openPeriscope } = usePeriscopeActions();
    const navigate = useNavigate();
    const overflow = count / max < 0.2;
    const handleOpenPeriscope = useCallback(() => {
        if (type) {
            openPeriscope({
                id,
                name,
                openedFromIndex: -1,
                type
            });
        }
        else {
            navigate(`${FULL_ROUTES.DATA_SECURITY}/${id}`);
        }
    }, [id, name, navigate, openPeriscope, type]);
    return (React.createElement("div", { className: classNames('access-statistics-row', className, { clickable }), onClick: clickable ? handleOpenPeriscope : undefined },
        React.createElement("div", { className: 'name-bar' },
            React.createElement(Tag, { className: classNames('color-bar', colorName), color: colorName, style: {
                    backgroundColor: getBackgroundColor(color),
                    borderColor: color,
                    width: `${(count / max) * 100}%`
                } }),
            React.createElement("div", { className: classNames('stat-details', { overflow }) },
                React.createElement(SonarText, null, name),
                React.createElement("div", null, extra))),
        React.createElement("div", { className: 'request-count' },
            React.createElement(SonarText, null, count.toLocaleString()))));
};
